'use client'

import dynamic from 'next/dynamic'
import { Button, Typography } from '@mui/material'

// Types
import type { BrownButtonProps } from '@/types/components/atoms/buttons/brown'

// Components
const ChevronRightIconAtom = dynamic(() => import('@/components/atoms/icons/chevron-right'))
const ExploreShapeAtom = dynamic(() => import('@/components/atoms/shapes/explore'))

const BrownButtonAtom = (props: BrownButtonProps) => {
	// Props
	const { children } = props

	return (
		<Button
			endIcon={<ChevronRightIconAtom />}
			sx={{
				color: 'common.white',
				bgcolor: 'inherit',
				'& .MuiButton-icon': { zIndex: 1 },
				'& .brown-shape-atom': {
					width: 1,
					height: 'auto',
					position: 'absolute',
					color: 'primary.main'
				}
			}}
		>
			<ExploreShapeAtom color="#824d3b" />

			<Typography component="span" zIndex={1}>
				{children}
			</Typography>
		</Button>
	)
}

export default BrownButtonAtom
